import { initialState } from '../constants';
import { createReducer } from '../helpers';
import { InterviewsReducerHandlers, GeneralReducerHandlers } from './handlers';
import { GeneralActionTypes } from '../actions/types';

const ratingsReducer = createReducer(
  initialState,
  {
    [GeneralActionTypes.resetStore]: GeneralReducerHandlers.resetStore(initialState),
    ...InterviewsReducerHandlers.getInterviewsInfo,
    ...InterviewsReducerHandlers.sendInterviewInvite,
    ...InterviewsReducerHandlers.updateInterview,
    ...InterviewsReducerHandlers.fetchProjectOverviewDataByProjectId,
    ...InterviewsReducerHandlers.fetchProjectOverviewDataByCustomerId,
    ...InterviewsReducerHandlers.attachFileToInterview,
    ...InterviewsReducerHandlers.deleteFileFromInterview,
    ...InterviewsReducerHandlers.downloadFileOfInterview,
    ...InterviewsReducerHandlers.toggleAudioFilesRequired,
    ...InterviewsReducerHandlers.getProjectAndBookData,
    ...InterviewsReducerHandlers.fetchChaptersAndResourcesByProjectId,
    ...InterviewsReducerHandlers.getBookSampleAndResourcesByProjectId,
    ...InterviewsReducerHandlers.transcribeFileOfInterview,
  },
);

export default ratingsReducer;
